import { Injectable } from '@angular/core';

import { NOT_APPLICABLE, TrackData, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

@Injectable()
export class OddsChangesConfirmationTrackingService {
    constructor(private trackingService: TrackingService) {}
    trackPopupShown(): void {
        const trackingData: TrackData = {
            ...this.getBaseTrackingData(),
            [trackingConstants.COMPONENT_ACTION_EVENT]: trackingConstants.LOAD,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: TrackingValues.OddsChangesPopup,
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
        };
        this.trackingService.track(trackingConstants.EVENT_CONTENT_VIEW, trackingData);
    }

    trackTooltipClick(tooltipShown: boolean): void {
        const trackingData: TrackData = {
            ...this.getBaseTrackingData(),
            [trackingConstants.COMPONENT_ACTION_EVENT]: tooltipShown ? TrackingValues.Click : trackingConstants.CLOSE,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: TrackingValues.InfoIcon,
            [trackingConstants.COMPONENT_POSITION_EVENT]: TrackingValues.OddsChangesPopup,
        };

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    trackSaveButtonClick(selectedValue: string | undefined): void {
        const trackingData: TrackData = {
            ...this.getBaseTrackingData(),
            [trackingConstants.COMPONENT_ACTION_EVENT]: TrackingValues.Click,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: TrackingValues.Save,
            [trackingConstants.COMPONENT_POSITION_EVENT]: TrackingValues[selectedValue as keyof typeof TrackingValues],
        };

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    trackSavePreferenceStatus(selectedValue: string | undefined, message: string, status: string): void {
        const trackingData: TrackData = {
            ...this.getBaseTrackingData(),
            [trackingConstants.COMPONENT_ACTION_EVENT]: status,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: message,
            [trackingConstants.COMPONENT_POSITION_EVENT]: TrackingValues[selectedValue as keyof typeof TrackingValues],
        };

        this.trackingService.track(trackingConstants.EVENT_CONTENT_VIEW, trackingData);
    }

    getBaseTrackingData(): TrackData {
        return {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: TrackingValues.BetSlip,
            [trackingConstants.COMPONENT_LABEL_EVENT]: TrackingValues.OddsChanges,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: TrackingValues.OddsChangesPopup,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        };
    }
}

export enum TrackingValues {
    BetSlip = 'betslip',
    OddsChanges = 'odds changes',
    OddsChangesPopup = 'odds changes popup',
    Click = 'click',
    Save = 'Save',
    InfoIcon = 'info icon',
    Confirm = 'confirm',
    Success = 'success',
    Error = 'error',
    Any = 'accept any odds',
    Higher = 'accept only higher odds',
    No = "don't accept odds changes",
}
